var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"flex":"1"}},[_c('div',{ref:"a",style:({height: _vm.height, width: _vm.width})}),_c('div',{staticStyle:{"font-size":"12px","top":"-30px","position":"relative"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }